import { useState } from "react";
import { Button, Form, Modal, message } from "antd";

import Heading from "components/Heading/Heading";
import DataTable from "components/Tables/DataTable";
import {
  useAddColorMutation,
  useDeleteColorMutation,
  useEditColorMutation,
  useGetColorsQuery,
} from "../../../redux/Service/colors";
import FormModal from "./FormModal"; // Adapt this modal for colors

function Colors() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const { data: colorsData, isLoading, isError } = useGetColorsQuery(undefined);
  const colors = colorsData?.ResponseObject ?? [];

  const [addColor, { isLoading: isAdding }] = useAddColorMutation();
  const [updateColor, { isLoading: isUpdating }] = useEditColorMutation();
  const [deleteColor, { isLoading: isDeleting }] = useDeleteColorMutation();

  const columns: any = [
    {
      title: "كود اللون",
      dataIndex: "ColorID",
      key: "ColorID",
    },
    {
      title: "اسم اللون",
      dataIndex: "ColorName",
      key: "ColorName",
      width: 120,
    },
  ];

  const handleOk = async (values: any) => {
    try {
      let response;
      if (isEditing) {
        response = await updateColor(values).unwrap();
      } else {
        response = await addColor(values).unwrap();
      }

      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل اللون بنجاح" : "تمت إضافة اللون بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleDeleteClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف اللون "${record.ColorName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteColor(record.ColorID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف اللون بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    setTimeout(() => {
      form.setFieldsValue(record);
    }, 0);
  };

  return (
    <>
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start my-2">
          <Button
            type="primary"
            style={{ width: "10rem" }}
            onClick={() => setIsModalOpen(true)}
          >
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          colors={colors}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          loading={isUpdating || isAdding}
        />

        <DataTable
          columns={columns}
          data={colors}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeleteClick}
          isLoading={isLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default Colors;
